<template>
    <DropdownV2>
        <template #button="{ open }">
            <div class="flex items-center nav-link"
                :class="open ? 'text-white stroke-white' : 'text-grey-900 stroke-grey-900 hover:text-white hover:stroke-white hover:cursor-pointer'"
            >
                <p class="!text-[inherit]"><slot name="button" /></p>
                <IconArrowDown :class="{ 'rotate-180': open }" class="h-[14px] w-[14px] ml-1 transition-all" />
            </div>
        </template>

        <template #menu>
            <div class="table-multi-select-menu min-w-[240px] !pt-0">
                <slot name="menu" />
            </div>
        </template>
    </DropdownV2>
</template>